/* tslint:disable */

declare var Object: any;
export interface ImplementationServiceInterface {
  "empId"?: string;
  "fullName"?: string;
  "posNameEn"?: string;
  "leaveCode": string;
  "leavenameEn"?: string;
  "leaveStartdate"?: Date;
  "leaveEnddate"?: Date;
  "totaldays"?: string;
  "remark"?: string;
  "status": number;
}

export class ImplementationService implements ImplementationServiceInterface {
  "empId": string;
  "fullName": string;
  "posNameEn": string;
  "leaveCode": string;
  "leavenameEn": string;
  "leaveStartdate": Date;
  "leaveEnddate": Date;
  "totaldays": string;
  "remark": string;
  "status": number;
  constructor(data?: ImplementationServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ImplementationService`.
   */
  public static getModelName() {
    return "ImplementationService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ImplementationService for dynamic purposes.
  **/
  public static factory(data: ImplementationServiceInterface): ImplementationService{
    return new ImplementationService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ImplementationService',
      plural: 'ImplementationServices',
      path: 'ImplementationServices',
      idName: 'id',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "leaveCode": {
          name: 'leaveCode',
          type: 'string'
        },
        "leavenameEn": {
          name: 'leavenameEn',
          type: 'string'
        },
        "leaveStartdate": {
          name: 'leaveStartdate',
          type: 'Date'
        },
        "leaveEnddate": {
          name: 'leaveEnddate',
          type: 'Date'
        },
        "totaldays": {
          name: 'totaldays',
          type: 'string'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ImplementationService.ts